@if (passFound && !loading) {
  <ix-pane-layout
    [borderless]="true"
    [layout]="'full-vertical'"
    [variant]="'inline'">
    <ix-pane
      heading="{{ 'battery_pass.private.interaction_history' | translate }}"
      slot="right"
      size="33%"
      [hideOnCollapse]="true"
      [expanded]="historyInteractionExpanded"
      (expandedChanged)="historyPaneExpandedChanged($event)"
      >
      @if (!passPublic && !passId.toUpperCase().startsWith('CX')) {
        <app-battery-interaction-history
          [passport]="passport"
        ></app-battery-interaction-history>
      }
    </ix-pane>
    <div slot="content">
      <ix-layout-grid class="h-100 w-100 position-relative" columns="12">
        <ix-row>
          <ix-col>
            <ix-content-header
              id="privateBatteryPassHeader"
              [hasBackButton]="true"
              (backButtonClick)="onBackButtonClick()"
              headerSubtitle="{{'battery_pass.edit.sub_header' | translate: {product: schemaName} }}"
              headerTitle="{{
                'battery_pass.private.header' | translate: {id: passDisplayName}
              }}">
              @if (!passPublic || !passId.toUpperCase().startsWith('CX')) {
                <!-- QR Code button -->
                @if (!WindowSizeService.windowSizeSmall()) {
                  <ix-button
                    (click)="onShowQrClick()"
                    class="me-2"
                    icon="qr-code"
                    id="privateBatteryPassQrCodeButton"
                    onkeypress=""
                    variant="secondary">
                    {{ 'battery_pass.private.show_qr_code' | translate }}
                  </ix-button>
                }
                @if (WindowSizeService.windowSizeSmall()) {
                  <ix-icon-button
                    (click)="onShowQrClick()"
                    class="me-2"
                    icon="qr-code"
                    id="privateBatteryPassQrCodeButtonSmallScreen"
                    onkeypress=""
                    variant="secondary"
                  ></ix-icon-button>
                }
                <!-- History button -->
                @if (WindowSizeService.windowSizeSmall()) {
                  <ix-icon-button
                    (click)="onHistoryButtonClick()"
                    [hidden]="!hasPassportOwnership()"
                    class="me-2"
                    icon="history"
                    onkeypress=""
                    variant="secondary"
                  ></ix-icon-button>
                }
                @if (!WindowSizeService.windowSizeSmall()) {
                  <ix-button
                    (click)="onHistoryButtonClick()"
                    [hidden]="!hasPassportOwnership()"
                    class="me-2"
                    icon="history"
                    id="privateBatteryPassHistoryButton"
                    onkeypress=""
                    variant="secondary"
                    >
                    {{ 'battery_pass.private.interaction_history' | translate }}
                  </ix-button>
                }
                <!-- Export button -->
                @if (!passPublic && !loading) {
                  <ix-dropdown-button
                    class="me-2"
                    icon="export"
                    id="privateBatteryPassExportDropdown"
                  label="{{
                  WindowSizeService.windowSizeSmall()
                    ? ''
                    : ('general.export' | translate)
                }}"
                    variant="secondary"
                    >
                    <ix-dropdown-item
                      (click)="exportPass('json')"
                      id="privateBatteryPassExportDropdownJson"
                    label="{{
                    'battery_pass.private.export_as_json' | translate
                  }}"
                      onkeypress=""
                    ></ix-dropdown-item>
                    <ix-dropdown-item
                      (click)="exportPass('csv')"
                      id="privateBatteryPassExportDropdownCsv"
                      label="{{ 'battery_pass.private.export_as_csv' | translate }}"
                      onkeypress=""
                    ></ix-dropdown-item>
                  </ix-dropdown-button>
                }
                <!-- Edit button -->
                @if (!WindowSizeService.windowSizeSmall()) {
                  <ix-button
                    *ngxPermissionsOnly="['DATA_MANAGER']"
                    [routerLink]="['/app/edit-passport/', passId]"
                    [hidden]="!hasPassportOwnership()"
                    class="ms-3 me-2"
                    icon="pen"
                    id="editBatteryPassButton"
                    variant="secondary">
                    {{ 'battery_pass.private.edit' | translate }}
                  </ix-button>
                }
                @if (WindowSizeService.windowSizeSmall()) {
                  <ix-icon-button
                    *ngxPermissionsOnly="['DATA_MANAGER']"
                    [routerLink]="['/app/edit-passport/', passId]"
                    [hidden]="!hasPassportOwnership()"
                    class="ms-3 me-2"
                    icon="pen"
                    id="editBatteryPassButtonSmallScreen"
                    variant="secondary"
                  ></ix-icon-button>
                }
                <!-- Remove button -->
                @if (!WindowSizeService.windowSizeSmall()) {
                  <ix-button
                    *ngxPermissionsOnly="['DATA_MANAGER']"
                    (click)="onRemoveClick()"
                    [hidden]="!hasPassportOwnership()"
                    icon="trashcan"
                    id="privateBatteryPassRemoveButton"
                    onkeypress=""
                    variant="danger-secondary">
                    {{ 'battery_pass.private.remove' | translate }}
                  </ix-button>
                }
                @if (WindowSizeService.windowSizeSmall()) {
                  <ix-icon-button
                    *ngxPermissionsOnly="['DATA_MANAGER']"
                    (click)="onRemoveClick()"
                    [hidden]="!hasPassportOwnership()"
                    icon="trashcan"
                    id="privateBatteryPassRemoveButtonSmallScreen"
                    onkeypress=""
                    variant="danger-secondary"
                  ></ix-icon-button>
                }
              }
            </ix-content-header>
          </ix-col>
        </ix-row>
        <app-pass-viewer
          [passport]="passport?.data"
          [schema]="schema"
          [uiSchema]="uiSchema"
          [showTabs]="showTabs"
        ></app-pass-viewer>
      </ix-layout-grid>
    </div>
  </ix-pane-layout>
}

@if (loading) {
  <div class="d-flex justify-content-center">
    <ix-spinner size="large" class="mt-5"></ix-spinner>
  </div>
}

@if (!passFound) {
  <div class="d-flex justify-content-center">
    <ix-empty-state
      class="mt-5"
      header="{{ 'battery_pass.list.no_passport_available' | translate }}"
      subHeader="{{ 'battery_pass.private.no_pass_sub_header' | translate }}"
      icon="error"
      action="{{ 'battery_pass.public.action' | translate }}"
    ></ix-empty-state>
  </div>
}

